import { notify } from '../components/common/AppToast';
import authService from '../services/authService';

export const STATUT_CREA_CLIENT = 'Créa Client';
export const STATUT_BAT_ENVOYE = 'BAT Envoyé';
export const STATUT_BAT_VALIDE = 'BAT Validé';

export const BAT_VALIDE_RESTRICTED_MESSAGE = 'Seul le graphiste peut passer le statut en BAT validé.';

export function isCreaClientStatut(value) {
  return String(value ?? '').trim() === STATUT_CREA_CLIENT;
}

export function isBatValideStatut(value) {
  return String(value ?? '').trim() === STATUT_BAT_VALIDE;
}

export function canSetBatValide() {
  return authService.isGraphiste() || authService.isSuperAdmin();
}

/** Superadmin : peut valider le BAT sans joindre de visuel. */
export function canSkipBatValideImage() {
  return authService.isSuperAdmin();
}

/** Graphiste, admin commercial ou superadmin : ajouter / modifier les fichiers créa a posteriori. */
export function canEditCreaPubFichiers() {
  return authService.isGraphiste()
    || authService.isAdminCommercial()
    || authService.isSuperAdmin();
}

/** Superadmin : retirer une ligne du suivi créa pub. */
export function canDeleteSuiviCreaPub() {
  return authService.isSuperAdmin();
}

export function isBatValideOptionLocked(value) {
  return isBatValideStatut(value) && !canSetBatValide();
}

export function batValideOptionTitle(value) {
  return isBatValideOptionLocked(value) ? BAT_VALIDE_RESTRICTED_MESSAGE : undefined;
}

export function interceptLockedBatValideChange(nextValue, currentValue) {
  if (
    isBatValideStatut(nextValue)
    && !isBatValideStatut(currentValue)
    && !canSetBatValide()
  ) {
    notify.warning(BAT_VALIDE_RESTRICTED_MESSAGE);
    return true;
  }

  return false;
}

export function interceptGraphisteBatValideRequest(nextValue, currentValue, vente, onRequestBatValide) {
  if (
    typeof onRequestBatValide !== 'function'
    || !vente?.id
    || !isBatValideStatut(nextValue)
    || isBatValideStatut(currentValue)
    || !canSetBatValide()
  ) {
    return false;
  }

  onRequestBatValide(vente);
  return true;
}

export function ventePeriodeLabel(vente) {
  if (!vente) return '—';
  if (vente.periode_label) return vente.periode_label;
  if (vente.semaine) return vente.semaine;
  const mois = vente.mois_label || vente.mois;
  const annee = vente.annee;
  if (mois && annee) return `${mois} ${annee}`;
  return '—';
}

export function venteCanalLabel(vente) {
  if (!vente) return '';
  if (vente.canal_label) return vente.canal_label;
  const canal = String(vente.canal || '').toLowerCase();
  if (canal === 'newsletter') return 'Newsletter';
  return canal ? canal.toUpperCase() : '';
}
